import script from "./WelfareActivityList.vue?vue&type=script&setup=true&lang=js"
export * from "./WelfareActivityList.vue?vue&type=script&setup=true&lang=js"

import "./WelfareActivityList.vue?vue&type=style&index=0&id=78755d8d&lang=css"

const __exports__ = script;

export default __exports__